import { h } from 'preact';
import {
  USERLANE_APP_ID,
  HUBSPOT_ID,
  BEAMER_ID,
  NOTIFICATION_ELEMENT_ID,
} from '../../constants';
import Userlane from './Userlane';
import { HubSpotWidget as HubSpot } from './HubSpot';
import Delighted from './Delighted';
import Beamer from './Beamer';

const isAccountFullyLoaded = account =>
  account.id !== null &&
  account.contractDetails.defaultPaymentSourceType !== undefined;

const USERLANE_LEFT_OFFSET_WITH_HUBSPOT = 166;

const Widgets = ({
  account,
  activateHubSpot,
  activateUserlane,
  locale,
  merchant,
  segments,
  showDelighted,
  showHubspot,
  isContractApp,
  beamerCustomAttributes,
  hubspotChatflow,
}) => {
  const shouldDisplayHubspot = HUBSPOT_ID && activateHubSpot;
  return (
    <div>
      {BEAMER_ID &&
        isAccountFullyLoaded(account) &&
        !isContractApp && (
          <Beamer
            email={account.email}
            firstName={account.firstName}
            lastName={account.lastName}
            locale={locale}
            productId={BEAMER_ID}
            segments={segments}
            targetElementId={NOTIFICATION_ELEMENT_ID}
            userId={account.id}
            customAttributes={beamerCustomAttributes}
          />
        )}
      {USERLANE_APP_ID &&
        (activateUserlane && (
          <Userlane
            appId={USERLANE_APP_ID}
            leftOffset={
              shouldDisplayHubspot
                ? USERLANE_LEFT_OFFSET_WITH_HUBSPOT
                : undefined
            }
            {...{ merchant, account }}
          />
        ))}
      {shouldDisplayHubspot && (
        <HubSpot
          hubId={HUBSPOT_ID}
          show={showHubspot}
          chatflow={hubspotChatflow}
          email={account.email}
          organizationId={account.organizationId}
        />
      )}
      {showDelighted &&
        account.email !== '' && (
          <Delighted locale={account.locale} email={account.email} />
        )}
    </div>
  );
};

export default Widgets;
